import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root'
})

export class ToasterService {

  constructor(private toastr: ToastrService,
              private _router: Router
  ) { }

  message(message: string, type: number, positionClass?: ToasterPosition,  timeOut?: number, url?: string): void {
    if (!positionClass) {
      positionClass = ToasterPosition.bottomCenter;
    }
    if (!timeOut) {
      timeOut = 6000;
    }

    let toastRef;
    const options = {
      positionClass,
      timeOut,
      closeButton: true,
      tapToDismiss: false,
      enableHtml: true, // Enable HTML in the message
      onActivateTick: true // Ensure that Angular change detection runs when the toastr is activated
    };
    this.toastr.clear();
    if (type === 1) {
      toastRef = this.toastr.success(message, 'Success:', options);
    } else if (type === 2) {
      this.toastr.error(message, 'Error:', { progressBar : true , positionClass, timeOut, closeButton: true, tapToDismiss: false, enableHtml : true });
    } else if (type === 3) {
      this.toastr.error(message, 'Error:', { positionClass, timeOut, closeButton: true, tapToDismiss: false });
    } else if (type === 4) {
      this.toastr.info(message, 'Info:', { positionClass, timeOut, closeButton: true, tapToDismiss: false });
    }

    if (toastRef && url) {
      //  toastRef.onTap.subscribe(() => this._router.navigate([url]));
      toastRef.onShown.subscribe(() => {
        const viewButton = document.querySelector('.toastr-view-button');
        if (viewButton) {
          viewButton.addEventListener('click', () => {
            this._router.navigate([url]);
          });
        }
      });
    }
  }
}

export enum ToasterPosition {
  topRight = 'toast-top-right',
  topLeft = 'toast-top-left',
  bottomRight = 'toast-bottom-right',
  bottomLeft = 'toast-bottom-left',
  bottomCenter = 'toast-bottom-center',
  topCenter = 'toast-top-center',
}
